var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBasic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "hex-shape",
    fillRule: "evenodd",
    stroke: "none",
    d: "M 50.015167 -0.00016 L 93.030655 24.825249 L 93.030655 74.476044 L 50.015167 99.320999 L 7.018764 74.476044 L 7.018764 24.825249 L 50.015167 -0.00016 Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "hex-icon basic-icon",
    transform: "translate(25,25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41 42 L 9 42 C 5.132813 42 2 38.867188 2 35 L 2 15 C 2 11.132813 5.132813 8 9 8 L 41 8 C 44.867188 8 48 11.132813 48 15 L 48 35 C 48 38.867188 44.867188 42 41 42 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasic);
export default __webpack_public_path__ + "static/media/basic.ea9de77e10e73d575ff3b4165366f6c0.svg";
export { ForwardRef as ReactComponent };